var exports = {
  "B": "Sidebar__d5W_zT",
};

module.exports = exports;
